import * as L from 'leaflet';

/** Numbered stop marker shared by the route layer and read-only preview. */
export function routeStopPinIcon(sequence: number, color: string, extraClass = ''): L.DivIcon {
  return L.divIcon({
    className: 'sr-stop-pin ' + extraClass,
    html:
      `<svg width="30" height="38" viewBox="0 0 30 38">`
      + `<path d="M15 37 C15 37 28 20.5 28 13.5 A13 13 0 1 0 2 13.5 `
      + `C2 20.5 15 37 15 37 Z" fill="${color}" stroke="#fff" `
      + `stroke-width="2.5" stroke-linejoin="round"/>`
      + `<text x="15" y="18.5" text-anchor="middle" fill="#fff" `
      + `font-family="system-ui,sans-serif" font-size="13" `
      + `font-weight="700">${sequence}</text></svg>`,
    // Anchored at the tail, so the point of the pin is the door - a
    // centre-anchored pin sits half a building north of its address.
    iconSize: [30, 38], iconAnchor: [15, 37],
  });
}
